//urls Backend
//const local = "http://localhost:3001";
//heroku
const heroku = "https://especiera-22f54012404d.herokuapp.com";

export const actual = heroku;